import { render, staticRenderFns } from "./TaxesList.vue?vue&type=template&id=f4c9a9fa&scoped=true"
import script from "./TaxesList.vue?vue&type=script&lang=js"
export * from "./TaxesList.vue?vue&type=script&lang=js"
import style0 from "./TaxesList.vue?vue&type=style&index=0&id=f4c9a9fa&prod&lang=scss&scoped=true"
import style1 from "./TaxesList.vue?vue&type=style&index=1&id=f4c9a9fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c9a9fa",
  null
  
)

export default component.exports